import React, { useMemo } from "react";
import { RCCGrid} from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import MetricsRanges from "src/components/MetricsRanges";
import { IMetricsTab} from "../interface";

const TabMetrics: React.FC<IMetricsTab> = ({ 
	useArrayControls, 
	metrics,
	defaultMetricId,
	control,
	setValue,
	errors,
	clearErrors,
	hidden
}) => {
	if(hidden) return null;
	
	const { translate} = useTranslation();
	  
	const {remove, append } = useArrayControls;
	const rangesList = useMemo(() => (
		<MetricsRanges
			names ={{
				table:"metrics",
				idName: "iqc004Id",
				initValueName:"iqc004Valorini",
				endValueName:"iqc004Valorfim",
				colorName:"iqc004Cor",
				metricIdName:"indicator.iqc001Taa006Id"
			}}
			source = {metrics}
			control={control}
			remove={remove}
			append={append}
			errors={errors}
			clearErrors={clearErrors}
			metricId={defaultMetricId?.toString()}
			setValue={setValue}
			titleText={translate("As faixas das métricas são utilizadas para colorir os períodos no painel de indicadores, informe os limites percentuais para cada faixa")}
			useMetricLov
		/>
	), [metrics,errors]);

	return(
		<RCCGrid container item justifyContent="center">
			<RCCGrid container item xs={12} sm={10} lg={8}>
				{rangesList}
			</RCCGrid>
		</RCCGrid>
	);
};
export default TabMetrics;


